import React from "react";
import RegisterForm from "../../components/Forms/RegisterForm/RegisterForm";
import loginStyles from "../Login/Login.module.css";

const Register: React.FC = () => {
  return (
    <div className={loginStyles.mainContainer}>
      <div className={loginStyles.leftPanelContainer}>
        <div className={loginStyles.header}>
          <img
            className={loginStyles.logo}
            src="/images/logo/company.svg"
            alt="logo"
          />
        </div>
        <h2>Join us now!</h2>
      </div>
      <div className={loginStyles.container}>
        <div className={loginStyles.loginFormContainer}>
          <RegisterForm />
        </div>
      </div>
    </div>
  );
};

export default Register;
